import { useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react'
import { MdOutlineDeleteForever } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { DeleteInstantBooking } from '../Modals/DeleteInstantBooking';

export const SingleInstantRow = ({ props, func, id }: any) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
      booking_id,
      lead_information:{first_name,last_name},
      expert_information:{full_name},
      session_time,
      booking_type,
      session_date,
    } = props;
    const navigate = useNavigate();
    const [modal, setModal] = useState("");
    return (
      <tr>
        <td>{booking_id}</td>
        <td>{first_name} {last_name}</td>
        <td>{full_name}</td>
        <td> {session_date} </td>
        <td>{session_time}</td>
        <td>{booking_type}</td>
        <td>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn action-btn disabledButton"
              onClick={() => navigate(`/instant/view/${booking_id}`)}
            >
              View
            </button>
          </div>
        </td>
        <td>
          <div className="d-flex align-items-center">
            <span title="Delete">
              <MdOutlineDeleteForever
                className="deleteButton pointer"
                onClick={() => {
                  setModal("deletemodal");
                  onOpen();
                }}
              />
            </span>
          </div>
        </td>
  
        {modal === "deletemodal" && (
          <DeleteInstantBooking isOpen={isOpen} onClose={onClose} func={func} id={booking_id} />
        )}
        {/* AddCommentModal */}
      </tr>
    );
  };
  